import { render, staticRenderFns } from "./order-return.vue?vue&type=template&id=647f83e3&scoped=true&"
import script from "./order-return.vue?vue&type=script&lang=js&"
export * from "./order-return.vue?vue&type=script&lang=js&"
import style0 from "./order-return.vue?vue&type=style&index=0&id=647f83e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647f83e3",
  null
  
)

export default component.exports